export type MarkerStyle = {
  colorClass: string;
  hoverColorClass: string;
};

/** Colors of a Strategy map marker (the volume heatmap tiers are gone: markers never show volume). */
export const DEFAULT_MARKER_STYLE: MarkerStyle = {
  colorClass: 'bg-indigo-600',
  hoverColorClass: 'bg-sky-600',
};
